const advertiserSteps = {
    ADVERTISER_DETAILS: 0,
    INVITATION: 1
};

export default {
    advertiserSteps
};
